import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "logout"
const LogoutIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.75 2.25C13.578 2.25 14.25 2.922 14.25 3.75V9.75H12.75V3.75H3V20.25H12.75V14.25H14.25V20.25C14.25 21.078 13.578 21.75 12.75 21.75H3C2.172 21.75 1.5 21.078 1.5 20.25V3.75C1.5 2.922 2.172 2.25 3 2.25z" />
          <path d="M22.436 12 17.03 17.405 15.97 16.345 19.564 12.75H4.5V11.25H19.564L15.97 7.655 17.03 6.595z" />
        </svg>
      }
    </span>
  )
}
export default LogoutIcon
